import { MicrositeButtonShape } from '@web/enums/MicrositeButtonShape';

export default function (buttonShape: MicrositeButtonShape): string {
  const buttonBorderRadius = {
    [MicrositeButtonShape.ROUNDED]: '0.5rem',
    [MicrositeButtonShape.CIRCULAR]: '1.5rem',
    [MicrositeButtonShape.SQUARE]: '0px',
  }[buttonShape];

  if (buttonBorderRadius === undefined) {
    throw new Error(`Unknown button shape: ${buttonShape}`);
  }

  return buttonBorderRadius;
}
